export const isDevelopmentEnv = () => {
  if (window.location.hostname.includes('localhost')) {
    return true;
  }

  return false;
};
